
export const sidebarBillApi ={
    topPart:{
        img:"./assets/images/dashboards/adminDashboard/sidebar/BSSmediumlogo.png"
    },
    
    menuItem: [
        {
            name:"Bill Page",
            link:"/billpage",
            img:"./assets/images/dashboards/adminDashboard/sidebar/collapsedicon.png",
            active:true,
            drpdwn:[],
            activeicon:"./assets/images/dashboards/adminDashboard/sidebar/colorediconofmenu.png"
        },
        {
            name:"Flex",
            link:"/flexvalueadashpage",
            img:"./assets/images/dashboards/adminDashboard/sidebar/collapsedicon.png",
            active:false,
            drpdwn:[
                {
                    item:"Flex Value",
                    link:"/flexvalueadashpage"
                },
                {
                    item:"Flex Value Set",
                    link:"/flexvaluesetadashpage"
                }
            ]
        },
      

    
    
    ]
}

